"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _dataGrid = _interopRequireDefault(require("../data-grid.js"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _navbar = _interopRequireDefault(require("./navbar.js"));

var _get = _interopRequireDefault(require("lodash/get"));

var _moduleLocalization = require("@eig-builder/module-localization");

var _useLocalStorage5 = _interopRequireDefault(require("@eig-builder/core-utils/hooks/useLocalStorage"));

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  .ag-status-bar {\n    display: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var defaultColDefinition = {
  resizable: true
};

var TableWrapper = _styledComponents["default"].div(_templateObject());

var getDefaultViewByGridSize = function getDefaultViewByGridSize(gridSize) {
  if (gridSize < 7) {
    return 'Cards';
  }

  return 'Table';
};

var Default = function Default(_ref) {
  var autocompleteProps = _ref.autocompleteProps,
      disableNavbar = _ref.disableNavbar,
      disableNavbarSearch = _ref.disableNavbarSearch,
      pagination = _ref.pagination,
      exportUrl = _ref.exportUrl,
      filterOptions = _ref.filterOptions,
      frameworkComponents = _ref.frameworkComponents,
      gridData = _ref.gridData,
      navbar = _ref.navbar,
      noRowsMessage = _ref.noRowsMessage,
      onCreateNew = _ref.onCreateNew,
      paginationPageSize = _ref.paginationPageSize,
      tableHeaders = _ref.tableHeaders,
      tableRowData = _ref.tableRowData,
      tag = _ref.tag,
      customView = _ref.customView,
      defaultView = _ref.defaultView,
      withAutocomplete = _ref.withAutocomplete,
      forceDataUpdate = _ref.forceDataUpdate,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["autocompleteProps", "disableNavbar", "disableNavbarSearch", "pagination", "exportUrl", "filterOptions", "frameworkComponents", "gridData", "navbar", "noRowsMessage", "onCreateNew", "paginationPageSize", "tableHeaders", "tableRowData", "tag", "customView", "defaultView", "withAutocomplete", "forceDataUpdate"]);

  var _useLocalize = (0, _moduleLocalization.useLocalize)(),
      localize = _useLocalize.localize; // Over here we are storing the last visited grid's size, so for the next skeleton loader we know what size we have to draw ;-)


  var _useLocalStorage = (0, _useLocalStorage5["default"])("GRID_SIZE_".concat(window.location.pathname), 200),
      _useLocalStorage2 = (0, _slicedToArray2["default"])(_useLocalStorage, 2),
      gridSize = _useLocalStorage2[0],
      setGridSize = _useLocalStorage2[1];

  var _useLocalStorage3 = (0, _useLocalStorage5["default"])("ROW_DATA_LENGTH_".concat(window.location.pathname), 0),
      _useLocalStorage4 = (0, _slicedToArray2["default"])(_useLocalStorage3, 2),
      rowDataLength = _useLocalStorage4[0],
      setRowDataLength = _useLocalStorage4[1];

  var serverSidePagination = restProps.serverSidePagination,
      datasource = restProps.datasource;
  var isMobile = (0, _useResponsiveQuery.useIsMobile)();
  (0, _react.useEffect)(function () {
    if (tableRowData && tableRowData.length) {
      setRowDataLength(tableRowData.length);
    }
  }, [setRowDataLength, tableRowData]);
  (0, _react.useEffect)(function () {
    var newGridSize = rowDataLength * 26 + 20;

    if (rowDataLength && gridSize !== newGridSize) {
      setGridSize(newGridSize);
      setRowDataLength(rowDataLength);
    }
  }, [gridSize, setGridSize, rowDataLength, setRowDataLength]);
  var autoCompleteValues = (0, _react.useMemo)(function () {
    return (0, _get["default"])(autocompleteProps, 'selectedSuggestions', []);
  }, [autocompleteProps]);
  return /*#__PURE__*/_react["default"].createElement(TableWrapper, null, /*#__PURE__*/_react["default"].createElement(_dataGrid["default"], {
    defaultView: defaultView || getDefaultViewByGridSize(rowDataLength),
    serverSidePagination: serverSidePagination,
    datasource: datasource,
    pageSize: paginationPageSize,
    forceDataUpdate: forceDataUpdate
  }, withAutocomplete && tableRowData && /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Autocomplete, (0, _extends2["default"])({
    suggestions: tableRowData
  }, autocompleteProps)), !disableNavbar && (navbar || /*#__PURE__*/_react["default"].createElement(_navbar["default"], {
    filterOptions: filterOptions,
    tableRowData: tableRowData,
    tag: tag,
    exportUrl: exportUrl,
    disableNavbarSearch: disableNavbarSearch
  })), /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Body, null, customView && /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Body.CustomView, (0, _extends2["default"])({
    headers: tableHeaders,
    rowData: serverSidePagination ? gridData === null || gridData === void 0 ? void 0 : gridData.data : tableRowData,
    customView: customView,
    pagination: pagination
  }, restProps)), (!isMobile || !customView) && /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Body.TableView, (0, _extends2["default"])({
    rowHeight: 60,
    columnDefs: tableHeaders.map(function (header) {
      return header.enableFilter ? header : _objectSpread({
        getQuickFilterText: function getQuickFilterText() {
          return null;
        }
      }, header);
    }).map(function (header) {
      return _objectSpread(_objectSpread({}, header), {}, {
        headerName: localize(header.headerName)
      });
    }),
    rowData: tableRowData,
    frameworkComponents: frameworkComponents,
    defaultColDef: defaultColDefinition,
    placeholderHeight: gridSize,
    noRowsMessage: noRowsMessage,
    paginationPageSize: paginationPageSize,
    autocompleteValues: autoCompleteValues,
    pagination: pagination
  }, restProps))), pagination && /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Footer, null, /*#__PURE__*/_react["default"].createElement(_dataGrid["default"].Footer.Pagination, (0, _extends2["default"])({
    totalCount: gridData === null || gridData === void 0 ? void 0 : gridData.total_count // eslint-disable-line
    ,
    pageSize: paginationPageSize || (gridData === null || gridData === void 0 ? void 0 : gridData.page_size) // eslint-disable-line

  }, restProps)))));
};

Default.propTypes = {
  autocompleteProps: _propTypes["default"].object,
  customView: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  defaultView: _propTypes["default"].oneOf(['Cards', 'Table']),
  disableNavbar: _propTypes["default"].bool,
  disableNavbarSearch: _propTypes["default"].bool,
  exportUrl: _propTypes["default"].string,
  filterOptions: _propTypes["default"].object,
  frameworkComponents: _propTypes["default"].object,
  forceDataUpdate: _propTypes["default"].func,
  gridData: _propTypes["default"].object,
  navbar: _propTypes["default"].element,
  noRowsMessage: _propTypes["default"].string,
  onCreateNew: _propTypes["default"].func,
  pagination: _propTypes["default"].bool,
  paginationPageSize: _propTypes["default"].number,
  tableHeaders: _propTypes["default"].array.isRequired,
  tableRowData: _propTypes["default"].array,
  tag: _propTypes["default"].string.isRequired,
  withAutocomplete: _propTypes["default"].bool
};
Default.defaultProps = {
  paginationPageSize: 24,
  forceDataUpdate: function forceDataUpdate() {}
};

var _default = (0, _react.memo)(Default);

exports["default"] = _default;